import Vue from 'vue';
import AuthModel from './AuthModel.js';

import Component from 'vue-class-component';


@Component
export default class Auth extends Vue{
    
    constructor(){
        super();
        this.username = "";
        this.password = "";

        document.addEventListener("keyup", event => {
            if(event.key == "Enter") {
                if (document.getElementById("login").value && document.getElementById("pass").value){
                    this.buttonClick();
                }
            }
        });
    }
    buttonClick()  {
        new AuthModel().postAuthData(this.username, this.password);         
    }
    handleChange(e, field) {
        this.$data[field] = e.target.value;
    } 
    render (h) {
		return(
			<div> 
				<div class="logo">
                    <img src="assets/img/logo.png" class="logo-text"> </img>
				</div>
				<div class="calltoaction-text">Спиши время и будет тебе счастье!</div>
				<div class="auth-form">
                    <input autofocus type="text" id="login" name="login" placeholder="Логин" class="input-common-text input-common "
                    value={this.$data.username} onChange={(e)=>{this.handleChange(e,'username')}}  onKeyup={(e)=>{this.handleChange(e,'username')}}/>
					<br/>
                    <input autofocus type="password" id="pass" name="pass" placeholder="Пароль" class="input-common-password input-common"
                    value={this.$data.password} onChange={(e) => { this.handleChange(e, 'password') }} onKeyup={(e) => { this.handleChange(e, 'password') }} />
                    <br/>
                    <button id="button" onClick={this.buttonClick}>ВОЙТИ</button>
				</div>
                
                <style jsx>{`
                    .logo{
                        height: 200px;
                        width: 181px;
                        top: 0px;
                        background-color: rgba(39, 51, 72, 1);
                        margin: auto;
                    }

                    .logo-text{
                        padding-left: 27px;
                        padding-top: 137px;
                    }

                    .calltoaction-text{
                        padding-top: 91px;
                        margin: auto;
                        text-align: center;
                        font-size: 16px;
                        font-family: 'Open Sans';
                    }

                    .auth-form{
                        text-align: center;
                        padding: 70px;
                        padding-bottom: 0;
                    }

                    input{
                        color: rgba(41, 41, 41, 1);
                        margin: auto;
                        border: none;
                        outline: none;
                        display: block;
                        font-family: 'Open Sans';
                    }


                    .input-common{

                        border-bottom: 1px solid  rgba(51, 51, 51, 1);
                        width: 260px;
                        padding: 12px;
                        font-size: 16px;

                    }

                    .input-common-text{
                        background-image: url("assets/img/user_ic.png");
                        background-repeat: no-repeat;
                        background-position: 4px; 
                        padding-left: 50px;
                    }

                    .input-common-password{
                        background-image: url("assets/img/lock_ic.png");
                        background-repeat: no-repeat;
                        background-position: 4px; 
                        padding-left: 50px;
                    }

                    button:hover{
                        background-color: rgba(25, 45, 81, 1);
                        border: none;
                        color: rgba(255, 255, 255, 1);
                    }  

                    button:disabled{
                        background-color: #fff;
                        border: 1px solid #b2b5ba;
                        color: #b2b5ba;
                    }     

                    button{
                        background-color: rgba(39, 51, 72, 1);
                        border: none;
                        color: rgba(255, 255, 255, 1);
                        margin-top: 40px;
                        font-size: 14px;
                        height: 35px;
                        width: 200px;
                        border-radius: 18px;
                        outline: none;
                    }  

				`}</style>
            </div>
            
		);
    }
}

//заглушка
/* if (this.username == "1" && this.password=="1"){
    this.setAccessToken("hiimtoken");
    this.$router.replace('/report');
}
else{
    alert("Неверные логин и/или пароль");
}
*/

/*     
password: 'md532437ec3507cd41978d5c7bff6d25fc4',
username: 'ddolnov', 
params.append('username', 'ddolnov');
params.append('password', 'md532437ec3507cd41978d5c7bff6d25fc4');
params.append('username', 'amalchuk');
params.append('password', 'md589bd66b9a5177c5953ebde44f96b921e');
*/


// WEBPACK FOOTER //
// ./src/Auth/Auth.js